import React, { Component } from 'react';
import { VDSManager } from '@vds/utilities';
import { BrowserRouter } from 'react-router-dom';

import Header from './Common/Header/Header';
import Footer from './Common/Footer/Footer'

import GBPortal from './Pages/GBPortal/GBPortal';
import IdleTimer from './utils/IdleTimer';

/*  basename={'/sub-directory'} */
class App extends Component {
  render() {
    return (
      <VDSManager>
        <div className="App">
          <BrowserRouter basename={`${process.env.PUBLIC_URL}`}>
            <div className="app-content">
              <IdleTimer/>
              <Header />
              <GBPortal />
              <Footer />
            </div>
          </BrowserRouter>
        </div>
      </VDSManager>

    );
  }
}

export default App;
